import { createTheme } from '@mui/material/styles';

// Tema azul ONPE - profesional y corporativo
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1e40af', // Azul ONPE oscuro
      light: '#3b82f6',
      dark: '#1e3a8a',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#0369a1', // Azul complementario
      light: '#0284c7',
      dark: '#075985',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f1f5f9',
      paper: '#ffffff',
    },
    text: {
      primary: '#1e293b',
      secondary: '#475569',
    },
    success: {
      main: '#10b981',
      light: '#34d399',
      dark: '#059669',
    },
    error: {
      main: '#ef4444',
      light: '#f87171',
      dark: '#dc2626',
    },
    warning: {
      main: '#f59e0b',
      light: '#fbbf24',
      dark: '#d97706',
    },
    info: {
      main: '#3b82f6',
      light: '#60a5fa',
      dark: '#2563eb',
    },
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      color: '#1e293b',
      letterSpacing: '-0.02em',
      '@media (max-width:600px)': {
        fontSize: '2rem',
      },
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 700,
      color: '#1e293b',
      letterSpacing: '-0.01em',
      '@media (max-width:600px)': {
        fontSize: '1.75rem',
      },
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
      color: '#1e293b',
      '@media (max-width:600px)': {
        fontSize: '1.5rem',
      },
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
      color: '#334155',
      '@media (max-width:600px)': {
        fontSize: '1.25rem',
      },
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
      color: '#475569',
      '@media (max-width:600px)': {
        fontSize: '1.1rem',
      },
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
      color: '#64748b',
    },
    button: {
      fontWeight: 600,
      letterSpacing: '0.02em',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
      '@media (max-width:600px)': {
        fontSize: '0.95rem',
      },
    },
  },
  shape: {
    borderRadius: 12,
  },
  shadows: [
    'none',
    '0 1px 2px 0 rgb(30 64 175 / 0.05)',
    '0 1px 3px 0 rgb(30 64 175 / 0.1), 0 1px 2px -1px rgb(30 64 175 / 0.1)',
    '0 4px 6px -1px rgb(30 64 175 / 0.1), 0 2px 4px -2px rgb(30 64 175 / 0.1)',
    '0 10px 15px -3px rgb(30 64 175 / 0.1), 0 4px 6px -4px rgb(30 64 175 / 0.1)',
    '0 20px 25px -5px rgb(30 64 175 / 0.1), 0 8px 10px -6px rgb(30 64 175 / 0.1)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
    '0 25px 50px -12px rgb(30 64 175 / 0.25)',
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 10,
          padding: '10px 24px',
          fontSize: '0.95rem',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '@media (max-width:600px)': {
            padding: '8px 16px',
            fontSize: '0.9rem',
          },
        },
        contained: {
          boxShadow: '0 4px 6px -1px rgb(30 64 175 / 0.2), 0 2px 4px -2px rgb(30 64 175 / 0.2)',
          '&:hover': {
            boxShadow: '0 10px 15px -3px rgb(30 64 175 / 0.3), 0 4px 6px -4px rgb(30 64 175 / 0.3)',
            transform: 'translateY(-2px)',
          },
          '&:active': {
            transform: 'translateY(0)',
          },
        },
        outlined: {
          borderWidth: '2px',
          '&:hover': {
            borderWidth: '2px',
            backgroundColor: 'rgba(30, 64, 175, 0.04)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px 0 rgb(30 64 175 / 0.08), 0 1px 2px -1px rgb(30 64 175 / 0.08)',
          borderRadius: 16,
          border: '1px solid rgba(30, 64, 175, 0.08)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          overflow: 'hidden',
          '@media (hover: hover)': {
            '&:hover': {
              boxShadow: '0 10px 15px -3px rgb(30 64 175 / 0.15), 0 4px 6px -4px rgb(30 64 175 / 0.15)',
              transform: 'translateY(-4px)',
              borderColor: 'rgba(30, 64, 175, 0.2)',
            },
          },
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '24px',
          '@media (max-width:600px)': {
            padding: '16px',
          },
          '&:last-child': {
            paddingBottom: '24px',
            '@media (max-width:600px)': {
              paddingBottom: '16px',
            },
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 6px -1px rgb(30 64 175 / 0.1), 0 2px 4px -2px rgb(30 64 175 / 0.1)',
          background: 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 50%, #1e3a8a 100%)',
          backdropFilter: 'blur(10px)',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: '1px solid rgba(30, 64, 175, 0.1)',
          background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          margin: '4px 8px',
          transition: 'all 0.2s ease-in-out',
          '@media (max-width:600px)': {
            margin: '2px 4px',
            padding: '8px 12px',
          },
          '&:hover': {
            backgroundColor: 'rgba(30, 64, 175, 0.08)',
            transform: 'translateX(4px)',
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(30, 64, 175, 0.12)',
            borderLeft: '4px solid #1e40af',
            '&:hover': {
              backgroundColor: 'rgba(30, 64, 175, 0.16)',
            },
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: '40px',
          '@media (max-width:600px)': {
            minWidth: '36px',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          borderRadius: 8,
          fontSize: '0.85rem',
          '@media (max-width:600px)': {
            fontSize: '0.8rem',
            height: '28px',
          },
        },
        filled: {
          boxShadow: '0 2px 4px rgba(30, 64, 175, 0.1)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            transition: 'all 0.2s ease-in-out',
            backgroundColor: '#ffffff',
            '&:hover': {
              boxShadow: '0 0 0 3px rgba(30, 64, 175, 0.08)',
            },
            '&.Mui-focused': {
              boxShadow: '0 0 0 3px rgba(30, 64, 175, 0.15)',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#1e40af',
                borderWidth: '2px',
              },
            },
          },
          '& .MuiInputLabel-root': {
            '@media (max-width:600px)': {
              fontSize: '0.9rem',
            },
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(30, 64, 175, 0.1)',
          '@media (max-width:600px)': {
            fontSize: '0.9rem',
          },
        },
        standardSuccess: {
          backgroundColor: '#d1fae5',
          color: '#065f46',
        },
        standardError: {
          backgroundColor: '#fee2e2',
          color: '#991b1b',
        },
        standardWarning: {
          backgroundColor: '#fef3c7',
          color: '#92400e',
        },
        standardInfo: {
          backgroundColor: '#dbeafe',
          color: '#1e40af',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
        elevation1: {
          boxShadow: '0 1px 3px 0 rgb(30 64 175 / 0.08), 0 1px 2px -1px rgb(30 64 175 / 0.08)',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#1e3a8a',
          fontSize: '0.85rem',
          borderRadius: 8,
          padding: '8px 12px',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          '@media (max-width:600px)': {
            paddingLeft: '12px',
            paddingRight: '12px',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '@media (max-width:600px)': {
            padding: '8px',
          },
        },
      },
    },
  },
});
